---
meta:
  - title: Compartir expedientes - IUSPRO Docs
  - description: Aprende a compartir expedientes con otros usuarios.
---

# Compartir expedientes

**Nota**: Esta función está disponible solo para cuentas empresariales.

## ¿Por qué compartir expedientes?

Cada expediente que se sube cuenta como un crédito. Cuando varios abogados necesitan trabajar con el mismo expediente, compartirlo evita:

- Gastar créditos innecesariamente
- Duplicar el mismo expediente varias veces
- Desperdiciar tiempo subiendo el mismo archivo múltiples veces

## Como compartir un expediente

1. **Abra el expediente** que desea compartir
2. **Busque la opción "Compartir"** en la interfaz del expediente
3. **Seleccione con quién compartir**:
   - **Todas las personas del bufete**: Todos los usuarios de su organización tendrán acceso
   - **Personas específicas**: Seleccione individualmente a quiénes compartir

## Beneficios de compartir

Cuando comparte un expediente:

- **Varios abogados pueden ver el mismo análisis** sin duplicar el trabajo
- **Todos pueden usar el chat con el asistente** dentro del expediente
- **Todos pueden usar el Redactor** con el contexto del caso
- **Se ahorra créditos** al no tener que subir el mismo expediente múltiples veces

## Colaboración en equipo

Si hay un expediente donde varias personas quieren:

- Ver el análisis
- Interactuar con el chat
- Usar el Redactor

Solo la primera persona que lo suba necesita hacerlo. Luego lo comparte con el equipo y todos pueden trabajar con él.

## Quién puede compartir

Cualquier usuario que haya subido un expediente puede compartirlo con otros miembros de su organización empresarial.
